import { dayjs } from 'src/services/date';

/**
 * Returns the date filter mode based on the set date range filter.
 *
 * @param {import('src/types/events-store').EventsStoreState} state
 */
export function allEventTypesSelected(state) {
  return state.typeFilter.length === 0;
}

/**
 * Returns the date filter mode based on the set date range filter.
 *
 * @param {import('src/types/events-store').EventsStoreState} state
 */
export function dateFilterMode(state) {
  return state.dateRangeFilter ? 'date-range' : 'most-recent';
}

/**
 * Returns true if there are active event filters.
 *
 * @param {import('src/types/events-store').EventsStoreState} state
 */
export function eventIsSelected(state) {
  return Boolean(state.selectedEvent);
}

/**
 * Returns the number of filters if filtering has been applied.
 *
 * @param {import('src/types/events-store').EventsStoreState} state
 */
export function filterCount(state) {
  let count = 0;

  if (state.dateRangeFilter) {
    count += 1;
  }

  if (state.vehicleFilter) {
    count += 1;
  }

  if (state.driverFilter) {
    count += 1;
  }

  if (state.typeFilter?.length) {
    count += 1;
  }

  return count;
}

/**
 * Returns all events, grouped by date.
 *
 * @param {import('src/types/events-store').EventsStoreState} state
 */
export function groupedEvents(state) {
  /** @type {{ [key: string]: import('src/types/events-feed').EventsFeedItem[] }} */
  const eventsByDate = {};

  state.events.forEach((item) => {
    const date = dayjs(item.timestamp).format('YYYYMMDD');
    if (!eventsByDate[date]) {
      eventsByDate[date] = [];
    }
    eventsByDate[date].push(item);
  });

  const dates = Object.keys(eventsByDate);

  dates.sort();
  dates.reverse();

  return dates.map((date) => ({
    date,
    activities: eventsByDate[date],
  }));
}

/**
 * Returns true if there are active event filters.
 *
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {import('src/types/events-store').EventsStoreGetters} getters
 */
export function hasFiltered(_, getters) {
  return getters.filterCount > 0;
}
